import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { toast, Toaster } from "react-hot-toast";

import { loginAtom } from "../../../services/atoms/auth.atoms";
import { ButtonLoading } from "../../../components/buttons/button-loading";
import { useAuthActions } from "../../../services/actions/auth.actions";

import logo from "../../../assets/gm-logo-name.svg";
import {
  ROUTES,
  SECRET_KEY,
} from "../../../helpers/constants";
import InputPass from "../../../components/inputs/input-pass";
import CryptoJS from 'crypto-js';
import { MailIcon } from "../../../assets/icons";
import SliderLogin from "../../../components/sliders/slider-login";
import { consumeSessionExpiredFlag } from "../../../utils/session-expired";
const initialFormState = {
  email: "",
  password: "",
  // formType: "signIn" // Not needed here anymore
};

const Login = () => {
  const [login, setSigned] = useRecoilState(loginAtom); // setSigned might still be needed for UI updates if not fully handled by atom effect
  const [formData, setFormData] = useState(initialFormState);
  const [rememberAccount, setRememberAccount] = useState(false);

  const { signInUser } = useAuthActions();

  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
   
    signInUser(email, password, rememberAccount);
  };

  const onChange = (e) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    if (consumeSessionExpiredFlag()) {
      toast("Tu sesión expiró. Vuelve a iniciar sesión para continuar.", { icon: "⚠️", duration: 6000 });
    }
  }, []);

  useEffect(() => {
    const getCookie = (name) => {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return cookie.substring(name.length + 1);
        }
      }
      return null;
    };

    const cookieName = '_sessionStorage';
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      const bytes = CryptoJS.AES.decrypt(cookieValue, SECRET_KEY);
      const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      setFormData((prevFormData) => ({
        ...prevFormData,
        email: data.email,
        password: data.password
      }));

      setRememberAccount(true)
    }

  }, [])
  return (
    <div className="gm-container-login">
      <div className="gm-form-container">
        <div className="gm-form-section">
          <Toaster />
          <div className="gm-login-welcome-container">
            <img src={logo} alt="growme-logo" />
            <h1>Inicia Sesión</h1>
            <span>Ingresa tus credenciales para acceder.</span>
          </div>
          <form className="gm-login-form-container" onSubmit={handleLogin}>
            <div className="gm-login-form-group">
              <label htmlFor="email">
                <input
                  className="gm-input-form-section"
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Correo Electrónico"
                  onChange={onChange}
                  required
                  disabled={login.loading}
                  value={formData.email}
                />
                <MailIcon />
              </label>
            </div>
            <InputPass
              className="gm-input-form-section"
              placeholder="Contraseña"
              id="password"
              name="password"
              onChange={onChange}
              required
              disabled={login.loading}
              value={formData.password}
            />
            <div className="gm-login-buttons">
              <ButtonLoading
                className="gm-button-login-section"
                type="submit"
                buttonLabel="Iniciar Sesión"
                disabled={login.loading}
                loading={login.loading}
              />
            </div>
            <footer className="gm-footer-login">
              <label>
                <input
                  className="input-checkbox"
                  type="checkbox"
                  checked={rememberAccount}
                  onChange={() => { setRememberAccount(!rememberAccount) }}
                  value={rememberAccount}
                />
                Recuérdame
              </label>
              <a href={`${ROUTES.RECOVER.route}`}>¿Olvidaste tu contraseña?</a>
            </footer>
          </form>
        </div>
      </div>
      <div className="gm-slider-container">
        <SliderLogin />
      </div>
    </div>

  )
};

export default Login;
